<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
        :disabled="disabled"
        v-model="formData.name"
        name="name"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写您的姓名' }]"
      />
      <van-field name="sex" label="性别">
        <template #input>
          <van-radio-group :disabled="disabled" v-model="formData.sex.key" direction="horizontal" @change="changeSex">
            <van-radio name="Female">女</van-radio>
            <van-radio name="Male">男</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 生日 -->
      <van-field
        :disabled="disabled"
        v-model="formData.birth"
        is-link
        name="datetimePicker"
        label="出生日期"
        readonly
        placeholder="点击选择生日"
        @click="showPickerBirth = true"
      />
      <van-popup v-if="!disabled" v-model="showPickerBirth" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirmBirth"
          @cancel="showPickerBirth = false"
        />
      </van-popup>
      <!-- 身高 -->
      <van-field name="height" label="身高（cm）">
        <template #input>
          <van-stepper :disabled="disabled" v-model="formData.height" step="1"  min="50" max="200" theme="round" button-size="22"  input-width="80px" />
        </template>
      </van-field>
      <!-- 体重 -->
      <van-field name="weight" label="体重（kg）">
        <template #input>
          <van-stepper :disabled="disabled" v-model="formData.weight" step="0.1" :decimal-length="1" min="20" max="100" theme="round" button-size="22" input-width="80px" />
        </template>
      </van-field>
      <!-- 状态 -->
      <van-field
        v-if="formData.sex.key == 'Female'"
        :disabled="disabled"
        v-model="formData.state.name"
        is-link
        readonly
        name="picker"
        label="状态"
        placeholder="点击选择状态"
        @click="showPickerState = true"
      />
      <van-popup v-if="!disabled" v-model="showPickerState" position="bottom">
        <van-picker
          value-key="name"
          :show-toolbar="true"
          :columns="stateOptions"
          :colunmsFieldNames="{ text: 'name', values: 'key', children: 'children' }"
          @confirm="onConfirmState"
          @cancel="showPickerState = false"
        />
      </van-popup>
      <!-- 末次月经时间 -->
      <van-field
        v-if="formData.sex.key == 'Female' && formData.state && formData.state.key && ['Pregnancy'].indexOf(formData.state.key) >= 0"
        :disabled="disabled"
        v-model="formData.lastMenstrualPeriod"
        is-link
        name="datetimePicker"
        label="末次月经时间选择"
        readonly
        placeholder="点击选择末次月经时间"
        @click="showPickerLastMenstrualPeriod = true"
      />
      <van-popup v-if="!disabled" v-model="showPickerLastMenstrualPeriod" position="bottom">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirmLastMenstrualPeriod"
          @cancel="showPickerLastMenstrualPeriod = false"
        />
      </van-popup>
      <!-- 孕前体重 -->
      <van-field v-if="formData.sex.key == 'Female' && formData.state && formData.state.key && ['Pregnancy','Lactation','NonLactation','MixedLactation'].indexOf(formData.state.key) >= 0" name="pregestationalWeight" label="孕前体重（kg）">
        <template #input>
          <van-stepper :disabled="disabled" v-model="formData.pregestationalWeight" step="0.1" :decimal-length="1" min="50" max="100" theme="round" button-size="22" />
        </template>
      </van-field>
      <!-- 单双胎 -->
      <van-field
        v-if="formData.sex.key == 'Female' && formData.state && formData.state.key && ['Pregnancy','Lactation','NonLactation','MixedLactation'].indexOf(formData.state.key) >= 0"
        :disabled="disabled"
        v-model="formData.type.name"
        is-link
        readonly
        name="picker"
        label="单双胎"
        placeholder="点击选择状态"
        @click="showPickerFetus = true"
      />
      <van-popup v-if="!disabled" v-model="showPickerFetus" position="bottom">
        <van-picker
          value-key="name"
          :show-toolbar="true"
          :columns="fetusTypeOptions"
          :colunmsFieldNames="{ text: 'name', values: 'key', children: 'children' }"
          @confirm="onConfirmFetus"
          @cancel="showPickerFetus = false"
        />
      </van-popup>
      <!-- 分娩方式 -->
      <van-field
        v-if="formData.sex.key == 'Female' && formData.state && formData.state.key && ['Lactation','NonLactation','MixedLactation'].indexOf(formData.state.key) >= 0"
        :disabled="disabled"
        v-model="formData.childbirth.name"
        is-link
        readonly
        name="picker"
        label="分娩方式"
        placeholder="点击选择状态"
        @click="showPickerChildbirth = true"
      />
      <van-popup v-if="!disabled" v-model="showPickerChildbirth" position="bottom">
        <van-picker
          value-key="name"
          :show-toolbar="true"
          :columns="childbirthTypeOptions"
          :colunmsFieldNames="{ text: 'name', values: 'key', children: 'children' }"
          @confirm="onConfirmChildbirth"
          @cancel="showPickerChildbirth = false"
        />
      </van-popup>
      <!-- 分娩时间 -->
      <van-field
        v-if="formData.sex.key == 'Female' && formData.state && formData.state.key && ['Lactation','NonLactation','MixedLactation'].indexOf(formData.state.key) >= 0"
        :disabled="disabled"
        v-model="formData.childbirthTime"
        is-link
        name="datetimePicker"
        label="分娩时间"
        readonly
        placeholder="点击选择末次月经时间"
        @click="showPickerChildbirthTime = true"
      />
      <van-popup v-if="!disabled" v-model="showPickerChildbirthTime" position="bottom">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirmChildbirthTime"
          @cancel="showPickerChildbirthTime = false"
        />
      </van-popup>
      <slot/>
      <div style="margin-top: 16px;">
        <van-button round block type="primary" native-type="submit" color="#ff9e19">
          {{ buttonLabel }}
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { Toast } from 'vant'
import Filter from "../../utils/filter"
import { Childbirth_Type, Wommen_State_Options, Fetus_Type } from "../../utils/constant"
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    buttonLabel: {
      type: String,
      default: '立即修改'
    }
  },
  watch: {
    data(val) {
      this.fillData(val)
    }
  },
  data() {
    return {
      currentDate: null,
      customFieldName: {
        text: 'name'
      },
      fetusTypeOptions: Fetus_Type,
      stateOptions: Wommen_State_Options,
      childbirthTypeOptions: Childbirth_Type,
      showPickerState: false,
      showPickerFetus: false,
      showPickerChildbirthTime: false,
      showPickerChildbirth: false,
      showPickerLastMenstrualPeriod: false,
      minDate: new Date(1930, 0, 1),
      mminDate: new Date(1980, 0, 1),
      maxDate: new Date(),
      showPickerBirth: false, 
      formData: {
        height: 160,
        width: 50,
        sex: {},
        type: {},
        state: { name: '无', key: 'None'},
        childbirth: {}
      }
    };
  },
  components: {
  },
  created() {
  },
  methods: {
    onSubmit() {
      console.info(this.formData)
      // updateUserInfo(this.formData).then(() => {
      //   Toast('修改成功')
      //   this.init()
      // })
      // 提交
      this.$emit('submit', {
        ...this.formData,
        type: this.formData.type ? this.formData.type : 'None',
        childbirth: this.formData.childbirth.key ? this.formData.childbirth : 'None'
      })
    },
    onConfirmFetus(val) {
      this.formData.type = val
      this.showPickerFetus = false
    },
    onConfirmChildbirth(val) {
      this.formData.childbirth = val
      this.showPickerChildbirth = false
    },
    onConfirmState(val) {
      this.formData.state = val
      this.showPickerState = false
      localStorage.setItem('state', val.key)
      var index = 0
      this.stateOptions.forEach(it => {
        if (it.key == val.key) {
          localStorage.setItem('womenStatus', index)
        }
        index++
      })
    },
    onConfirmBirth(val) {
      this.formData.birth = Filter.formatDateTime(val)
      this.showPickerBirth = false
    },
    onConfirmLastMenstrualPeriod(val) {
      this.formData.lastMenstrualPeriod = Filter.formatDateTime(val)
      this.showPickerLastMenstrualPeriod = false
    },
    onConfirmChildbirthTime(val) {
      this.formData.childbirthTime = Filter.formatDateTime(val)
      this.showPickerChildbirthTime = false
    },
    changeSex(val) {
      localStorage.setItem('sex', val)
    },
    fillData(res) {
      this.formData = res
      if (!res.state || !res.state.key) {
        this.formData.state = { name: '无', key: 'None'}
      } else {
        var index = 0
        this.stateOptions.forEach(it => {
          if (it.key == res.state.key) {
            localStorage.setItem('womenStatus', index)
          }
          index++
        })
      }
      if (!res.type || !res.type.key) {
        this.formData.type = { name: '无', key: 'None'}
      }
      if (!res.childbirth || !res.childbirth.key) {
        this.formData.childbirth = { name: '无', key: 'None'}
      }
      if (!res.sex) {
        this.formData.sex = {}
      }
      if (!res.height) {
        this.formData.height = 160
      }
      if (!res.weight) {
        this.formData.weight = 50
      }
      if (!res.birth) {
        this.currentDate = new Date(2000, 0, 1)
        this.formData.birth = '2000-1-1 00:00:00'
      } else {
        this.currentDate = new Date(this.formData.birth)
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/css/style.css');
.block {
  margin-top: 40px;
  padding: 0 40px;
}
</style>